<template>
  <transition-group name='fade'>
    <div @click="defaultMask" @touchmove.prevent class="mask" key="1" v-if="show"></div>
    <div class="pop" key="2" v-show="show"  >
      <div style="overflow:auto; max-height: 200px">
        <el-form :inline="true"  class="demo-form-inline">
          <div v-for="item in labelList">
            <el-form-item :label="item.lowerCH" style="margin-left: 10px">
              <el-input type='number' v-model="item.low"></el-input>
            </el-form-item>
            <el-form-item :label="item.upperCH" style="margin-left: -40px">
              <el-input type='number' v-model="item.up"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <el-form :inline="true">
        <el-form-item style="text-align: center;">
          <el-button @click="btnOK">{{confirm}}</el-button>
          <el-button @click="btnCancel">{{cancel}}</el-button>
        </el-form-item>
      </el-form>

<!--      <el-form :model="form" class="form-el" label-width="110px" ref="form">-->
<!--        <el-form-item :label="upper">-->
<!--          <el-input type='number' v-model="form.up"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item :label="lower">-->
<!--          <el-input type='number' v-model="form.low"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item>-->
<!--          <el-button @click="btnCancel">取消</el-button>-->
<!--          <el-button @click="btnOK">确定</el-button>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
    </div>
  </transition-group>

</template>

<script>
  import {clientInfo, getCredentials} from "../../untils/api/home";

  export default {
    name: 'Popup',
    data() {
      return {
        show: false,
        deviceInfo: {},
        labelList:[],
        initList:[],
        confirm:'',
        cancel:'',
        errorMessage: '',
        errorMessage1:'',
      }
    },

    mounted() {
      if (window.history && window.history.pushState) {
        window.addEventListener("popstate", this.defaultMask, false);
      }

      if(localStorage.getItem('locale') === 'en-US'){
        this.confirm = 'Confirm';
        this.cancel = 'Cancel';
        this.errorMessage = 'Data Error Please Fill In Again'
        this.errorMessage1 = ' Input Error Please Input Again';
      } else {
        this.confirm = '确定';
        this.cancel = '取消';
        this.errorMessage = '未填写数据或上下限值相同，请重新填写';
        this.errorMessage1 = '下限值大于上限值';
      }
    },

    destroyed() {
      window.removeEventListener("popstate", this.defaultMask, false);
    },


    methods: {
      /**
       * 确定上传值
       */
      btnOK() {
        this.show = false;
        let upLowList = [];
        let warnList = [];
        let flg = true;
        for(let i = 0; i < this.labelList.length; i++){
          if((parseFloat(this.labelList[i].low)< parseFloat(this.labelList[i].up)) &&
            (parseFloat(this.labelList[i].low) !== parseFloat(this.initList[i].low) || parseFloat(this.labelList[i].up) !== parseFloat(this.initList[i].up)) ){
            let param = {};
            param[this.labelList[i].upperEN] = this.labelList[i].up;
            param[this.labelList[i].lowerEN] = this.labelList[i].low;
            upLowList.push(param);
            warnList.push([this.labelList[i].upperEN.substring(0,this.labelList[i].upperEN.length - 3),parseFloat(this.labelList[i].up),parseFloat(this.labelList[i].low)])
          }else if(parseFloat(this.labelList[i].low) > parseFloat(this.labelList[i].up)){
            flg = false;
            this.labelList[i].up = this.initList[i].up;
            this.labelList[i].low = this.initList[i].low;
            let _this = this;
            if(localStorage.getItem('locale') === 'en-US'){
              setTimeout(function () {
                _this.$message({
                  showClose: true,
                  type: "warning",
                  message: _this.labelList[i].lowerCH.substring(0, _this.labelList[i].lowerCH.length -4) + _this.errorMessage1
                },3);
              })
            } else {
              setTimeout(function () {
                _this.$message({
                  showClose: true,
                  type: "warning",
                  message: _this.labelList[i].lowerCH.substring(0, _this.labelList[i].lowerCH.length -2) + _this.errorMessage1
                },3);
              })
            }
          } else if (parseFloat(this.labelList[i].low)=== parseFloat(this.labelList[i].up)) {
            this.labelList[i].up = this.initList[i].up;
            this.labelList[i].low = this.initList[i].low;
          }
        }
        if(upLowList.length > 0){
          localStorage.setItem("warnList",JSON.stringify(warnList))
          localStorage.setItem("upLowList",JSON.stringify(upLowList));
          this.getAccessToken(upLowList);
        } else if(flg){
          this.$message({
            showClose: true,
            type: "warning",
            message: this.errorMessage
          });
        }
      },

      /**
       * 取消
       */
      btnCancel() {
        this.show = false;
        for(let i = 0; i < this.labelList.length; i++){
          this.labelList[i].up = this.initList[i].up;
          this.labelList[i].low = this.initList[i].low;
        }
        this.click()
      },

      /**
       * 弹窗以外的区域
       */
      defaultMask() {
        this.show = false;
        for(let i = 0; i < this.labelList.length; i++){
          this.labelList[i].up = this.initList[i].up;
          this.labelList[i].low = this.initList[i].low;
        }
        this.click()
      },

      /**
       * 获取访问令牌
       */
      getAccessToken(upLowList) {
        //访问api获取设备信息
        getCredentials(this.deviceInfo.id).then(response => {
          //向客户端传值
          this.setClientInfo(response.credentialsId,upLowList);
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 向客户端传值
       * @param credentialsId
       */
      setClientInfo(credentialsId,upLowList) {
        for(let i = 0; i < upLowList.length; i++){
          clientInfo(credentialsId, upLowList[i]).then(response => {
            if (response === '') {
              //上传成功
              // this.$message({
              //   showClose: true,
              //   type: "info",
              //   message: this.upper + '值为：' + this.form.up + '\xa0\xa0\xa0\xa0下限值为：' + this.form.low
              // });
            } else {
              //上传失败
              this.$message({
                showClose: true,
                type: "warning",
                message: this.errorMessage
              });
            }
          }).catch(error => {
            console.log("error", error)
          })
        }
      }
    },
  }
</script>

<style lang="less" scoped>
  // 渐变过渡
  .fade-enter,
  .fade-leave-active {
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.35s;
  }

  .mask {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
  }

  .pop {
    min-height: 200px;
    min-width: 25%;
    background: #58a1ff;
    border-radius: 8px;
    position: fixed;
    top: 39%;
    left: 50%;
    margin-left: -40%;
    z-index: 9999;
    text-align: center;

    /*.form-el {*/
    /*  margin-top: 30px;*/
    /*  margin-right: 10px;*/
    /*  margin-left: 10px;*/
    /*  text-align: center;*/
    /*  color: #ffffff;*/
    /*}*/

    .el-button {
      background-color: #58a1ff;
      outline: none;
      /*border: none;*/
      color: #ffffff;
      font-size: 16px;
      appearance: none;
      -webkit-appearance: none;
      vertical-align: middle;
      /*float: right;*/
      text-align: center;
      margin-bottom: 15px;
      margin-top: 10px;
      color: #08FEED;
      border-radius: 10px;
    }

    .el-form-item{
      margin-top: 10px;
      margin-bottom: 5px;
    }
    .el-form--inline .el-form-item {
      margin-left: 0px;
      margin-right: 10px;
    }
    .el-input {
      width: 60%;
      margin-left: -50px;
    }

    /deep/ .el-form-item__label {
      color: #ffffff;
      min-width: 145px;
      margin-left: 35px;
      text-align: center;
    }
  }
  .meun-switch {
    position: fixed;
    top: 69%;
    left: 20%;
    z-index: 2001;
    cursor: pointer;
    width: 20%;
    height: 10%;
    padding: 5px;
    transition: all 0.25s;

    &.leave {
      left: -65px;
    }
    &.active {
      left: 0;
    }
    &:hover {
      transform: scale(1.02);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/popup/dialogPop.vue